










































































































import { Component, Mixins } from "vue-property-decorator";
import UserFilter from "../filters/UserFilter.vue";
import MultiProfessionListUserFilter from "../filters/MultiProfessionListUserFilter.vue";
import DepartmentListUserFilter from "../filters/DepartmentListUserFilter.vue";
import ProjectTeamMemberFilter from "../filters/ProjectTeamMemberFilter.vue";
import BelongedAllDepartmentsUserFilter from "../filters/BelongedAllDepartmentsUserFilter.vue";
import DesignatedDoctorUserFilter from "../filters/DesignatedDoctorUserFilter.vue";
import MultiOrderableUserListSelector from "../selectors/MultiOrderableUserListSelector.vue";
import UserDetailViewer from "../viewers/UserDetailViewer.vue";
import { MultiOrderableUserListSelectorDialogMixin } from "./mixins";

@Component({
  components: {
    UserFilter,
    MultiProfessionListUserFilter,
    DepartmentListUserFilter,
    ProjectTeamMemberFilter,
    BelongedAllDepartmentsUserFilter,
    MultiOrderableUserListSelector,
    UserDetailViewer,
    DesignatedDoctorUserFilter,
  },
})
export default class MultiOrderableUserListSelectorDialog extends Mixins(MultiOrderableUserListSelectorDialogMixin) {
  async openedDialog(): Promise<void> {
    await this.$nextTick();
    if (this.isDepartmentFeatureEnable) {// 起動時に科で職員の初回絞り込みが行われる.診療科非表示時は全職員を表示し選択できるようにする
      const userFilter = this.$refs.userFilter as UserFilter;
      userFilter.focus();
      const departmentFilter = this.$refs.departmentFilter as DepartmentListUserFilter;
      departmentFilter.scrollIntoView();
    }
  }
}
